// extracted by mini-css-extract-plugin
module.exports = {"techtomedNav":"Navigation_techtomedNav__Ygwjr","NavbarBrand":"Navigation_NavbarBrand__20mQD"};